import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MaterialDetailsForMaterialReferenceInspectorFragment = { __typename: 'Material', id: string, legacyId: number, name?: string | null, organization?: { __typename: 'Organization', legacyId: number, name?: string | null } | null, cyclesRevisions?: Array<{ __typename: 'MaterialRevision', id: string, legacyId: number, number: number }> | null, latestCyclesRevision?: { __typename: 'MaterialRevision', id: string, legacyId: number, number: number } | null, galleryImage?: { __typename: 'DataObject', id: string } | null };

export type GetMaterialDetailsForMaterialReferenceInspectorQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type GetMaterialDetailsForMaterialReferenceInspectorQuery = { __typename: 'Query', material: { __typename: 'Material', id: string, legacyId: number, name?: string | null, organization?: { __typename: 'Organization', legacyId: number, name?: string | null } | null, cyclesRevisions?: Array<{ __typename: 'MaterialRevision', id: string, legacyId: number, number: number }> | null, latestCyclesRevision?: { __typename: 'MaterialRevision', id: string, legacyId: number, number: number } | null, galleryImage?: { __typename: 'DataObject', id: string } | null } };

export const MaterialDetailsForMaterialReferenceInspectorFragmentDoc = gql`
    fragment MaterialDetailsForMaterialReferenceInspector on Material {
  id
  legacyId
  name
  organization {
    legacyId
    name
  }
  cyclesRevisions {
    id
    legacyId
    number
  }
  latestCyclesRevision {
    id
    legacyId
    number
  }
  galleryImage {
    id
  }
}
    `;
export const GetMaterialDetailsForMaterialReferenceInspectorDocument = gql`
    query getMaterialDetailsForMaterialReferenceInspector($legacyId: Int!) {
  material(legacyId: $legacyId) {
    ...MaterialDetailsForMaterialReferenceInspector
  }
}
    ${MaterialDetailsForMaterialReferenceInspectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialDetailsForMaterialReferenceInspectorGQL extends Apollo.Query<GetMaterialDetailsForMaterialReferenceInspectorQuery, GetMaterialDetailsForMaterialReferenceInspectorQueryVariables> {
    override document = GetMaterialDetailsForMaterialReferenceInspectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }